export default "__VITE_ASSET__DuWciVEe__"